import { datadogLogs } from '../datadog-logs';
import { Logger } from '../../logging';

export const logWarning = (
  logger: Logger,
  loggerName: string,
  e: Error,
  context: object
) => {
  logger.warn(loggerName, `${e?.name}: ${e?.message}`, context);
  datadogLogs.logger.warn(`${e?.name}: ${e?.message}`, {
    context: context,
  });
};

export const logInfo = (
  logger: Logger,
  loggerName: string,
  messageName: string,
  message: string,
  context: object
) => {
  logger.info(loggerName, `${messageName}: ${message}`, context);
  datadogLogs.logger.info(`${messageName}: ${message}`, {
    context: context,
  });
};
